var _path, _circle, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.443,
    height: 15.443,
    viewBox: "0 0 15.443 15.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31232",
    "data-name": "Path 31232",
    d: "M7.093.025A7.721,7.721,0,0,0,.879,11.3a1.844,1.844,0,0,1,.093,1.492L0,15.443l2.809-.936a1.834,1.834,0,0,1,1.412.1A7.722,7.722,0,1,0,7.093.025Z",
    transform: "translate(0 0)",
    fill: "#39be9d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1232",
    "data-name": "Ellipse 1232",
    cx: 6.317,
    cy: 6.317,
    r: 6.317,
    transform: "translate(1.404 1.404)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1233",
    "data-name": "Ellipse 1233",
    cx: 0.877,
    cy: 0.876,
    rx: 0.877,
    ry: 0.876,
    transform: "translate(6.844 3.73)",
    fill: "#39be9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31233",
    "data-name": "Path 31233",
    d: "M26.663,28.083h0A.663.663,0,0,1,26,27.42V23.663A.663.663,0,0,1,26.663,23h0a.663.663,0,0,1,.663.663V27.42A.663.663,0,0,1,26.663,28.083Z",
    transform: "translate(-18.942 -16.592)",
    fill: "#39be9d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.433d386e1454e0142e02a735413d3700.svg";
export { ForwardRef as ReactComponent };